// extracted by mini-css-extract-plugin
module.exports = {"main":"MediaCard-module--main--1YZ7T","imageFrame":"MediaCard-module--imageFrame--1_2lN","image":"MediaCard-module--image--1Gs7B","caption":"MediaCard-module--caption--39IHQ"};